import { render, staticRenderFns } from "./WalletsList.vue?vue&type=template&id=85ae3d9a&scoped=true&"
import script from "./WalletsList.vue?vue&type=script&lang=js&"
export * from "./WalletsList.vue?vue&type=script&lang=js&"
import style0 from "./WalletsList.vue?vue&type=style&index=0&id=85ae3d9a&lang=scss&scoped=true&"
import style1 from "./WalletsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ae3d9a",
  null
  
)

export default component.exports